import React from "react";
import "../assets/styles/homepage.css";

const Homepage = () => {
  return (
    <div className="homepage">
      <h1>Welcome to Talent Poll App</h1>
    </div>
  );
};

export default Homepage;
